import React from 'react';
import PowerbiManageRouter from './PowerbiManageRouter';

export default function PowerbiManagePage() {
  return <PowerbiManageRouter />;
}
